import { render, staticRenderFns } from "./OrderEmisionGeneralBoardRenovation.vue?vue&type=template&id=9b5025b4"
import script from "./OrderEmisionGeneralBoardRenovation.vue?vue&type=script&lang=js"
export * from "./OrderEmisionGeneralBoardRenovation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports